import axios from '../axios'

/*
 * 陪玩师列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/technologyApply/selectTechnologyByPage',
        method: 'post',
        data
    })
}

export const manualSet = (data) => {
    return axios({
        url: '/serviceFeeSetting/manualSet',
        method: 'post',
        data
    })
}

export const getHistory = (data) => {
    return axios({
        url: '/serviceFeeSetting/getHistory',
        method: 'get',
        data
    })
}

export const add = (data) => {
    return axios({
        url: '/serviceFeeSetting/add',
        method: 'post',
        data
    })
}

export const upgradeTechnologyLevel = (data) => {
    return axios({
        url: '/member/upgradeTechnologyLevel',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/play/playlist.js